
export const SERVER_URL = process.env.REACT_APP_MODE === 'dev' ?
    `http://${process.env.REACT_APP_LOCAL_API}`
	:
    `https://${process.env.REACT_APP_API_URL}`;
export const API_URL = `${SERVER_URL}/graphql`;
export const CLIENT_VERSION = '2.2.3';
export const WS_URL = process.env.REACT_APP_MODE === 'dev' ? `ws://${process.env.REACT_APP_LOCAL_API}/subscriptions` : `wss://${process.env.REACT_APP_API_URL}/subscriptions`;
